import { RouterModule, SubApp, createRoute } from '@tokamakjs/react';

import { AuthApi } from './api';
import { AuthGuard } from './guards/auth.guard';
import {
  ConfirmationController,
  CreateOrJoinCompanyAccountController,
  LoginController,
  ResetPasswordController,
  SignupController,
} from './routes';
import { AppService, AuthService } from './services';
import { AppController } from './wrapper';

@SubApp({
  routing: [
    createRoute('/', AppController, [
      createRoute('login', LoginController, []),
      createRoute('sign-up', SignupController, []),
      createRoute('create-join-company', CreateOrJoinCompanyAccountController, []),
      createRoute('confirmation', ConfirmationController, []),
      createRoute('reset-password', ResetPasswordController, []),
    ]),
  ],
  providers: [AuthService, AuthApi, AppService, AuthGuard],
  imports: [RouterModule],
})
export class AppModule {}
